import { Mic, Play } from 'lucide-react';
import type { Product } from './types';

export const callRecordingSystem: Product = {
  id: 'call-recording-system',
  title: 'Call Recording System',
  subtitle: 'Enterprise AI-Powered Call Recording & Conversation Intelligence Platform',
  description: 'Transform your contact center with our comprehensive call recording solution featuring AI transcription, real-time monitoring, quality scoring, and advanced conversation intelligence—designed for BPO and call center environments with enterprise-grade security and compliance.',
  icon: Mic,
  image: 'https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80',
  category: 'Operations & Quality',
  status: 'Live',
  businessTypes: ['#call-center', '#bpo', '#customer-service', '#quality-assurance', '#compliance'],
  features: [
    // Omnichannel Recording
    'Automatic Call Recording with 100% Capture Rate',
    'VoIP Integration (Cisco, Avaya, Genesys, Five9)',
    'Synchronized Screen Recording with Call Audio',
    'Video Conference Recording (Zoom, Teams, WebEx)',
    'Mobile Call Capture & Softphone Recording',
    'Multi-Channel Unified View (Voice, Chat, Email)',
    'Pause/Resume Controls for Sensitive Data',
    'Dual-Channel Recording for Advanced Analytics',
    
    // AI Transcription & Intelligence
    'Real-Time Transcription with 99%+ Accuracy',
    'Speaker Diarization (Agent vs Customer)',
    'AI Keyword & Phrase Detection',
    'Real-Time Sentiment & Emotion Analysis',
    'Automatic Topic Classification',
    'AI Action Item Extraction',
    'Automatic Call Summarization',
    'Customer Intent Recognition',
    'Automated Compliance Scoring',
    'Multi-Language Support (40+ Languages)',
    
    // Quality Monitoring
    'Live Call Monitoring with Whisper Coaching',
    'AI-Driven Automated Quality Scoring',
    'Custom Evaluation Forms & Scorecards',
    'QA Calibration Tools & Sessions',
    'AI Root Cause Analysis',
    'Proactive Trend Detection & Alerts',
    'Industry Benchmark Comparisons',
    'Real-Time Compliance Violation Alerts',
    
    // Agent Coaching & Development
    'AI-Generated Coaching Recommendations',
    'Best Practice Call Library',
    'Skill Gap Analysis with Training Plans',
    'Anonymous Peer Comparison Benchmarking',
    'Agent Self-Service Review Portal',
    'Performance Gamification & Leaderboards',
    'Structured Coaching Workflow & Tracking',
    
    // Security & Compliance
    'End-to-End AES-256 Encryption',
    'GDPR Compliance with Consent Management',
    'PCI-DSS Level 1 Certified Compliance',
    'HIPAA Healthcare-Grade Security',
    'Role-Based Access Control (RBAC)',
    'Complete Audit Trail & Logging',
    'Automated Retention Policies',
    'Legal Hold for Litigation',
    'Data Residency Options (UK, EU, US, APAC)',
    
    // Analytics & Integrations
    'Real-Time Executive Dashboards',
    'Custom Report Builder with Scheduling',
    'CRM Integration (Salesforce, HubSpot, Dynamics)',
    'WFM Integration (NICE, Verint, Calabrio)',
    'Ticketing Integration (Zendesk, ServiceNow)',
    'BI Export (Tableau, Power BI, Looker)',
    'RESTful API & Webhook Events'
  ],
  pricing: { setup: 30000, monthly: 1380 },
  color: 'from-red-600 to-orange-700',
  demoConfig: {
    type: 'interactive',
    url: '/call-recording/demo',
    title: 'Experience AI-Powered Call Recording',
    description: 'Explore our comprehensive call recording platform with real-time transcription, quality monitoring, and conversation intelligence',
    buttonText: 'Launch Demo',
    icon: Play,
    buttonColor: 'bg-gradient-to-r from-red-600 to-orange-600 hover:from-red-700 hover:to-orange-700'
  }
};
